import { getNlsString } from '../../nls/nlsRuntime'
import type { NlsInterpolationValues } from '../../nls/nlsTypes'
import type { NlsKey } from '../../nls/strings_nls'
import type { CreditTxnType } from '../../services/creditTransactionsService'
import type { CreditsScope } from '../../context/creditsContextCore'
import { SETTINGS_SECTION_NLS_KEYS, type SettingsSection } from './settingsNavigationModel'

export type SettingsNlsT = (key: NlsKey, values?: NlsInterpolationValues) => string

const defaultSettingsT: SettingsNlsT = (key, values) => getNlsString(key, values)

export const getSettingsSectionMeta = (section: SettingsSection, t: SettingsNlsT = defaultSettingsT) => {
  const keys = SETTINGS_SECTION_NLS_KEYS[section]
  return {
    title: t(keys.title),
    detail: t(keys.detail),
  }
}

export const getSettingsPanelHeaderNls = (section: SettingsSection, t: SettingsNlsT = defaultSettingsT) => {
  const keys = SETTINGS_SECTION_NLS_KEYS[section]
  return {
    title: t(keys.panelTitle ?? keys.title),
    subtitle: t(keys.panelSubtitle),
  }
}

export const getSettingsCreditScopeLabel = (scope: CreditsScope | undefined, t: SettingsNlsT = defaultSettingsT): string | null => {
  if (scope === 'personal') return t('NLSSettingsCreditPersonalWallet')
  if (scope === 'workspace') return t('NLSSettingsCreditWorkspaceBalance')
  return null
}

export const getSettingsCreditTransactionTypeLabel = (type: CreditTxnType, t: SettingsNlsT = defaultSettingsT) => {
  if (type === 'SIGNUP_BONUS') return t('NLSSettingsCreditTxnSignupBonus')
  if (type === 'ENGAGEMENT_REWARD') return t('NLSSettingsCreditTxnReward')
  if (type === 'PLAN_GRANT') return t('NLSSettingsCreditTxnPlanGrant')
  if (type === 'PURCHASE') return t('NLSSettingsCreditTxnPurchase')
  if (type === 'TRANSFER_IN') return t('NLSSettingsCreditTxnTransferIn')
  if (type === 'TRANSFER_OUT') return t('NLSSettingsCreditTxnTransferOut')
  if (type === 'RESERVATION') return t('NLSSettingsCreditTxnReserved')
  if (type === 'COMMIT') return t('NLSSettingsCreditTxnCommitted')
  if (type === 'RELEASE') return t('NLSSettingsCreditTxnReleased')
  if (type === 'REFUND') return t('NLSSettingsCreditTxnRefund')
  return t('NLSSettingsCreditTxnAdjustment')
}
